export default __webpack_public_path__ + "static/media/1-donando-ropa.9b58aaca.jpg";